import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=c6cbd08e&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\DevOpsAgent\\agent1\\_work\\10\\s\\Site\\Source\\Web\\Marketing.UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6cbd08e')) {
      api.createRecord('c6cbd08e', component.options)
    } else {
      api.reload('c6cbd08e', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=c6cbd08e&", function () {
      api.rerender('c6cbd08e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Views/Marketing/ProForm/components/shared/Button.vue"
export default component.exports